import React from 'react'
import { DashboardSkeleton, PublicPageSkeleton, AuthSkeleton } from './components'

const DashboardHome = React.lazy(
  () => import(/* webpackChunkName: "DashboardHome" */ './scenes/Dashboard/DashboardHome')
)

const DashAssetUpload = React.lazy(
  () =>
    import(/* webpackChunkName: "DashboardAssetUpload" */ './scenes/Dashboard/DashboardAssetUpload')
)

const DashInstagramBioLinks = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardInstagramBioLinks" */ './scenes/Dashboard/DashboardInstagramBioLinks'
    )
)

const DashContributions = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardContributions" */ './scenes/Dashboard/DashboardContributions'
    )
)

const DashChallenges = React.lazy(
  () =>
    import(/* webpackChunkName: "DashboardChallenges" */ './scenes/Dashboard/DashboardChallenges')
)

const DashChallenge = React.lazy(
  () => import(/* webpackChunkName: "DashboardChallenge" */ './scenes/Dashboard/DashboardChallenge')
)

const DashChallengesNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardChallengesNew" */ './scenes/Dashboard/DashboardChallengesNew'
    )
)

const DashNotifications = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardNotifications" */ './scenes/Dashboard/DashboardNotifications'
    )
)

const DashReceivedLikes = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardReceivedLikes" */ './scenes/Dashboard/DashboardReceivedLikes'
    )
)

const DashSubscriptions = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSubscriptions" */ './scenes/Dashboard/DashboardSubscriptions'
    )
)

const DashboardBill = React.lazy(
  () => import(/* webpackChunkName: "DashboardBill" */ './scenes/Dashboard/DashboardBill')
)

const DashboardBillSelection = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardBillSelection" */ './scenes/Dashboard/DashboardBillSelection'
    )
)

const DashboardOpps = React.lazy(
  () => import(/* webpackChunkName: "DashboardOpps" */ './scenes/Dashboard/DashboardOpps')
)

const DashboardOppsNew = React.lazy(
  () => import(/* webpackChunkName: "DashboardOppsNew" */ './scenes/Dashboard/DashboardOppsNew')
)

const DashboardOpp = React.lazy(
  () => import(/* webpackChunkName: "DashboardOpp" */ './scenes/Dashboard/DashboardOpp')
)

const DashOppActivity = React.lazy(
  () => import(/* webpackChunkName: "DashOppActivity" */ './scenes/Dashboard/DashboardOppActivity')
)

const DashOppPersonActivity = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashOppPersonActivity" */ './scenes/Dashboard/DashboardOppPersonActivity'
    )
)

const DashPersonActivity = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashPersonActivity" */ './scenes/Dashboard/DashboardPersonActivity'
    )
)

const DashUpdateMembership = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashUpdateMembership" */ './scenes/Dashboard/DashboardUpdatePersonMembership'
    )
)

const DashParticipantDocuments = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashParticipantDocuments" */ './scenes/Namespaced/Sef/DashboardParticipantDocuments'
    )
)

const DashPlatformEvents = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardPlatformEvents" */ './scenes/Dashboard/DashboardPlatformEvents'
    )
)

const DashEmailActivity = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardEmailActivity" */ './scenes/Dashboard/DashboardEmailActivity'
    )
)

const DashPersonalGoals = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardPersonalGoals" */ './scenes/Dashboard/DashboardPersonalGoals'
    )
)
const DashPersonalGoalNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardPersonalGoalNew" */ './scenes/Dashboard/DashboardPersonalGoalNew'
    )
)

const DashStories = React.lazy(
  () => import(/* webpackChunkName: "DashboardStories" */ './scenes/Dashboard/DashboardStories')
)
const DashStoryNew = React.lazy(
  () => import(/* webpackChunkName: "DashboardStoryNew" */ './scenes/Dashboard/DashboardStoryNew')
)

const DashStory = React.lazy(
  () => import(/* webpackChunkName: "DashboardStory" */ './scenes/Dashboard/DashboardStory')
)

const DashboardCamps = React.lazy(
  () => import(/* webpackChunkName: "DashboardCamps" */ './scenes/Dashboard/DashboardCamps')
)

const DashboardCampNew = React.lazy(
  () => import(/* webpackChunkName: "DashboardCampNew" */ './scenes/Dashboard/DashboardCampNew')
)

const DashboardCamp = React.lazy(
  () => import(/* webpackChunkName: "DashboardCamp" */ './scenes/Dashboard/DashboardCamp')
)

const DashboardTeamNew = React.lazy(
  () => import(/* webpackChunkName: "DashboardTeamNew" */ './scenes/Dashboard/DashboardTeamNew')
)

const DashTeamMembers = React.lazy(
  () => import(/* webpackChunkName: "DashTeamMembers" */ './scenes/Dashboard/DashboardTeamMembers')
)

const DashTeams = React.lazy(
  () => import(/* webpackChunkName: "DashboardTeams" */ './scenes/Dashboard/DashboardTeams')
)

const DashSquads = React.lazy(
  () => import(/* webpackChunkName: "DashboardSquads" */ './scenes/Dashboard/DashboardSquads')
)

const DashTeam = React.lazy(
  () => import(/* webpackChunkName: "DashboardTeam" */ './scenes/Dashboard/DashboardTeam')
)

const DashTeamGroup = React.lazy(
  () => import(/* webpackChunkName: "DashboardTeamGroup" */ './scenes/Dashboard/DashboardTeamGroup')
)

const DashNotFound = React.lazy(
  () => import(/* webpackChunkName: "DashboardNotFound" */ './scenes/Dashboard/DashboardNotFound')
)

const DashAccount = React.lazy(
  () => import(/* webpackChunkName: "DashboardAccount" */ './scenes/Dashboard/DashboardAccount')
)

const DashUserAccountPrefs = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardUserAccountPrefs" */ './scenes/Dashboard/Account/UserNotificationPreferences'
    )
)

const DashBoost = React.lazy(
  () => import(/* webpackChunkName: "DashboardBoost" */ './scenes/Dashboard/DashboardBoost')
)

const DashboardOrgs = React.lazy(
  () => import(/* webpackChunkName: "DashboardOrgs" */ './scenes/Dashboard/DashboardOrgs')
)
const DashboardOrgNew = React.lazy(
  () => import(/* webpackChunkName: "DashboardOrgNew" */ './scenes/Dashboard/DashboardOrgNew')
)
const DashboardOrg = React.lazy(
  () => import(/* webpackChunkName: "DashboardOrg" */ './scenes/Dashboard/DashboardOrg')
)
const DashboardOrgMembers = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashOrgMembers" */ './scenes/Dashboard/DashboardOrganisationMembers'
    )
)

const DashboardOrgVerify = React.lazy(
  () => import(/* webpackChunkName: "DashboardOrgVerify" */ './scenes/Dashboard/DashboardOrgVerify')
)

const DashboardOrgGoals = React.lazy(
  () => import(/* webpackChunkName: "DashboardOrgGoals" */ './scenes/Dashboard/DashboardOrgGoals')
)
const DashboardOrgGoal = React.lazy(
  () => import(/* webpackChunkName: "DashboardOrgGoal" */ './scenes/Dashboard/DashboardOrgGoal')
)
const DashboardOrgGoalNew = React.lazy(
  () =>
    import(/* webpackChunkName: "DashboardOrgGoalNew" */ './scenes/Dashboard/DashboardOrgGoalNew')
)

const DashboardOrgGoalMilestoneNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardOrgGoalMilestoneNew" */ './scenes/Dashboard/DashboardOrgGoalMilestoneNew'
    )
)
const DashboardOrgGoalMilestone = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardOrgGoalMilestone" */ './scenes/Dashboard/DashboardOrgGoalMilestone'
    )
)

const DashboardOrgFaq = React.lazy(
  () => import(/* webpackChunkName: "DashboardOrgFaq" */ './scenes/Dashboard/DashboardOrgFaq')
)
const DashboardOrgFaqs = React.lazy(
  () => import(/* webpackChunkName: "DashboardOrgFaqs" */ './scenes/Dashboard/DashboardOrgFaqs')
)
const DashboardOrgFaqNew = React.lazy(
  () => import(/* webpackChunkName: "DashboardOrgFaqNew" */ './scenes/Dashboard/DashboardOrgFaqNew')
)

const DashboardPeopleNew = React.lazy(
  () => import(/* webpackChunkName: "DashboardPeopleNew" */ './scenes/Dashboard/DashboardPeopleNew')
)

const AsyncDashboardPeople = React.lazy(
  () => import(/* webpackChunkName: "DashPeopleIndex" */ './scenes/Dashboard/DashboardPeople')
)

const AsyncTerms = React.lazy(() => import(/* webpackChunkName: "Terms" */ './scenes/Terms/Terms'))
const AsyncAboutUs = React.lazy(
  () => import(/* webpackChunkName: "AboutUs" */ './scenes/AboutUs/index')
)
const AsyncCareers = React.lazy(
  () => import(/* webpackChunkName: "Careers" */ './scenes/AboutUs/Careers')
)
const AsyncHomePage = React.lazy(() => import(/* webpackChunkName: "Home" */ './scenes/Home'))
const AsyncSefHomePage = React.lazy(
  () => import(/* webpackChunkName: "SefHome" */ './scenes/Namespaced/Sef/SefHome')
)
const AsyncExtrasPage = React.lazy(
  () => import(/* webpackChunkName: "Extras" */ './scenes/MarketingPages/Extras')
)

const AsyncFeedPage = React.lazy(
  () => import(/* webpackChunkName: "FeedPage" */ './scenes/FeedPage/FeedPage')
)

const AsyncNonprofitPricing = React.lazy(
  () => import(/* webpackChunkName: "NonprofitPricing" */ './scenes/Pricing/Nonprofits')
)
const AsyncBusinessPricing = React.lazy(
  () => import(/* webpackChunkName: "BusinessPricing" */ './scenes/Pricing/Business')
)
const AsyncEducationPricing = React.lazy(
  () => import(/* webpackChunkName: "EducationPricing" */ './scenes/Pricing/Education')
)
const AsyncPricingIndex = React.lazy(
  () => import(/* webpackChunkName: "PricingIndex" */ './scenes/Pricing')
)

const AsyncProcessPlatformPayment = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProcessPlatformPayment" */ './scenes/Payments/ProcessPlatformPayment'
    )
)
const AsyncProcessDonation = React.lazy(
  () => import(/* webpackChunkName: "ProcessDonation" */ './scenes/Payments/ProcessDonation')
)

const AsyncDocsPage = React.lazy(() => import(/* webpackChunkName: "Docs" */ './scenes/Docs/Docs'))
const AsyncPrivacyPolicy = React.lazy(
  () => import(/* webpackChunkName: "Terms" */ './scenes/PrivacyPolicy')
)

const AsyncNotFound = React.lazy(
  () => import(/* webpackChunkName: "NotFound" */ './scenes/NotFound/NotFound')
)

const AsyncInstagramBioLinks = React.lazy(
  () =>
    import(
      /* webpackChunkName: "InstagramBioLinks" */ './scenes/InstagramBioLinks/InstagramBioLinks'
    )
)

const AsyncOzowDonationCompletion = React.lazy(
  () =>
    import(/* webpackChunkName: "OzowDonationCompletion" */ './scenes/Ozow/OzowDonationCompletion')
)

const AsyncOzowDonationFailure = React.lazy(
  () => import(/* webpackChunkName: "OzowDonationFailure" */ './scenes/Ozow/OzowDonationFailure')
)

const AsyncLogin = React.lazy(() => import(/* webpackChunkName: "Login" */ './scenes/Login/Login'))

const AsyncEmailConfirmation = React.lazy(
  () => import(/* webpackChunkName: "EmailConfirmation" */ './scenes/Login/EmailConfirmation')
)

const AsyncProbation = React.lazy(
  () => import(/* webpackChunkName: "Probation" */ './scenes/Login/Probation')
)

const AsyncPasswordReset = React.lazy(
  () => import(/* webpackChunkName: "PasswordReset" */ './scenes/PasswordReset/PasswordReset')
)

const AsyncMagicLogin = React.lazy(
  () => import(/* webpackChunkName: "MagicLogin" */ './scenes/PasswordReset/MagicLogin')
)

const AsyncPasswordSetup = React.lazy(
  () => import(/* webpackChunkName: "PasswordSetup" */ './scenes/PasswordSetup/PasswordSetup')
)

const AsyncCampaign = React.lazy(
  () => import(/* webpackChunkName: "Campaign" */ './scenes/Campaign/Campaign')
)

const AsyncOpportunity = React.lazy(
  () => import(/* webpackChunkName: "Opportunity" */ './scenes/Opportunities/Opportunity')
)

const AsyncOrgDescription = React.lazy(
  () => import(/* webpackChunkName: "OrgDescription" */ './scenes/Organisations/OrgDescription')
)

const AsyncOrgFaqs = React.lazy(
  () => import(/* webpackChunkName: "OrgFaqs" */ './scenes/Organisations/OrgFaqs')
)

const AsyncOrgActivity = React.lazy(
  () => import(/* webpackChunkName: "OrgActivity" */ './scenes/Organisations/OrgActivity')
)

const AsyncOrgGoal = React.lazy(
  () => import(/* webpackChunkName: "OrgGoal" */ './scenes/Organisations/OrgGoal')
)
const AsyncOrgGoals = React.lazy(
  () => import(/* webpackChunkName: "OrgGoals" */ './scenes/Organisations/OrgGoals')
)
const AsyncOrgWebsites = React.lazy(
  () => import(/* webpackChunkName: "OrgWebsites" */ './scenes/Organisations/OrgWebsites')
)

const AsyncOrgBenefactors = React.lazy(
  () => import(/* webpackChunkName: "OrgBenefactors" */ './scenes/Organisations/OrgBenefactors')
)

const AsyncOrgCauses = React.lazy(
  () => import(/* webpackChunkName: "OrgCauses" */ './scenes/Organisations/OrgCauses')
)

const AsyncRequestOrganisationMembership = React.lazy(
  () =>
    import(
      /* webpackChunkName: "RequestOrganisationMembership" */ './scenes/Organisations/RequestOrganisationMembership'
    )
)

const AsyncManageOrgInvite = React.lazy(
  () => import(/* webpackChunkName: "ManageOrgInvite" */ './scenes/Organisations/ManageOrgInvite')
)

const AsyncClaimOrganisation = React.lazy(
  () =>
    import(/* webpackChunkName: "ClaimOrganisation" */ './scenes/Organisations/ClaimOrganisation')
)

const AsyncClaimOrganisationRequest = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ClaimOrganisationRequest" */ './scenes/Organisations/ClaimOrganisationRequest'
    )
)

const AsyncUser = React.lazy(() => import(/* webpackChunkName: "User" */ './scenes/Users/User'))
const AsyncUserChallenges = React.lazy(
  () => import(/* webpackChunkName: "UserChallenges" */ './scenes/Users/UserChallenges')
)
const AsyncUserHostedOpps = React.lazy(
  () => import(/* webpackChunkName: "UserHostedOpps" */ './scenes/Users/UserHostedOpps')
)
const AsyncUserJoinedOpps = React.lazy(
  () => import(/* webpackChunkName: "UserJoinedOpps" */ './scenes/Users/UserJoinedOpps')
)
const AsyncUserOrgs = React.lazy(
  () => import(/* webpackChunkName: "UserOrgs" */ './scenes/Users/UserOrgs')
)
const AsyncUserStories = React.lazy(
  () => import(/* webpackChunkName: "UserStories" */ './scenes/Users/UserStories')
)

const AsyncMoneyDonationConfirmation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "MoneyDonationConfirmation" */ './scenes/DonationConfirmations/MoneyDonationConfirmation'
    )
)

const AsyncOrgMoneyDonationConfirmation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "OrgMoneyDonationConfirmation" */ './scenes/DonationConfirmations/OrgMoneyDonationConfirmation'
    )
)

const AsyncGoodsDonationConfirmation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "GoodsDonationConfirmation" */ './scenes/DonationConfirmations/GoodsDonationConfirmation'
    )
)

const AsyncHostFeedback = React.lazy(
  () => import(/* webpackChunkName: "HostFeedback" */ './scenes/Feedback/HostFeedback')
)

const AsyncVolunteerFeedback = React.lazy(
  () => import(/* webpackChunkName: "VolunteerFeedback" */ './scenes/Feedback/VolunteerFeedback')
)

const AsyncPersonalGoodsDonationConfirmationRequest = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PersonalGoodsDonationConfirmationRequest" */ './scenes/DonationConfirmations/PersonalGoodsDonationConfirmationRequest'
    )
)

const AsyncPersonalMoneyDonationConfirmationRequest = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PersonalMoneyDonationConfirmationRequest" */ './scenes/DonationConfirmations/PersonalMoneyDonationConfirmationRequest'
    )
)

const AsyncOrgGoodsDonationConfirmation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "OrgGoodsDonationConfirmation" */ './scenes/DonationConfirmations/OrgGoodsDonationConfirmation'
    )
)

const AsyncOrgGoodsDonationConfirmationRequest = React.lazy(
  () =>
    import(
      /* webpackChunkName: "OrgGoodsDonationConfirmationRequest" */ './scenes/DonationConfirmations/OrgGoodsDonationConfirmationRequest'
    )
)

const AsyncOrgMoneyDonationConfirmationRequest = React.lazy(
  () =>
    import(
      /* webpackChunkName: "OrgMoneyDonationConfirmationRequest" */ './scenes/DonationConfirmations/OrgMoneyDonationConfirmationRequest'
    )
)

const AsyncChallengeCheckin = React.lazy(
  () => import(/* webpackChunkName: "ChallengeCheckin" */ './scenes/Feedback/ChallengeCheckin')
)

const AsyncCompaniesMarketingPage = React.lazy(
  () => import(/* webpackChunkName: "CompaniesMarketingPage" */ './scenes/MarketingPages/Companies')
)
const AsyncEducationMarketingPage = React.lazy(
  () => import(/* webpackChunkName: "EducationMarketingPage" */ './scenes/MarketingPages/Education')
)
const AsyncIndividualsMarketingPage = React.lazy(
  () =>
    import(/* webpackChunkName: "IndividualsMarketingPage" */ './scenes/MarketingPages/Individuals')
)
const AsyncNonprofitsMarketingPage = React.lazy(
  () =>
    import(/* webpackChunkName: "NonprofitsMarketingPage" */ './scenes/MarketingPages/Nonprofits')
)

const AsyncCampaigns = React.lazy(
  () => import(/* webpackChunkName: "Campaigns" */ './scenes/MarketingPages/Campaigns')
)
const AsyncCategories = React.lazy(
  () => import(/* webpackChunkName: "Categories" */ './scenes/MarketingPages/Categories')
)

const AsyncSpecs = React.lazy(() => import(/* webpackChunkName: "Specs" */ './scenes/Misc/Specs'))
const AsyncValues = React.lazy(
  () => import(/* webpackChunkName: "Values" */ './scenes/MarketingPages/Values')
)

const AsyncChallengeSearch = React.lazy(
  () => import(/* webpackChunkName: "ChallengeSearch" */ './scenes/Search/ChallengeSearch')
)
const AsyncNonProfitSearch = React.lazy(
  () => import(/* webpackChunkName: "NonProfitSearch" */ './scenes/Search/NonProfitSearch')
)
const AsyncOppSearch = React.lazy(
  () => import(/* webpackChunkName: "OppSearch" */ './scenes/Search/OppSearch')
)
const AsyncOrgSearch = React.lazy(
  () => import(/* webpackChunkName: "OrgSearch" */ './scenes/Search/OrgSearch')
)

const AsyncJoinBrowniePoints = React.lazy(
  () => import(/* webpackChunkName: "JoinBrowniePoints" */ './scenes/Onboarding/JoinBrowniePoints')
)

const AsyncCompleteOnboarding = React.lazy(
  () =>
    import(/* webpackChunkName: "CompleteOnboarding" */ './scenes/Onboarding/CompleteOnboarding')
)

const AsyncStories = React.lazy(
  () => import(/* webpackChunkName: "Stories" */ './scenes/Stories/Stories')
)

const withDashboardSkeleton = WrappedComponent => props => (
  <React.Suspense fallback={<DashboardSkeleton />}>
    <WrappedComponent {...props} />
  </React.Suspense>
)

const withPublicPageSkeleton = WrappedComponent => props => (
  <React.Suspense fallback={<PublicPageSkeleton />}>
    <WrappedComponent {...props} />
  </React.Suspense>
)

const withAuthSkeleton = WrappedComponent => props => (
  <React.Suspense fallback={<AuthSkeleton />}>
    <WrappedComponent {...props} />
  </React.Suspense>
)

///
///
/// Start of DGMT-specific routes
///
///

const DgmtHomePage = React.lazy(
  () => import(/* webpackChunkName: "DgmtHomePage" */ './scenes/Namespaced/Dgmt/Home')
)

const DgmtDiscoverWebsites = React.lazy(
  () => import(/* webpackChunkName: "DgmtDiscover" */ './scenes/Namespaced/Dgmt/HomeBackup')
)

const DashDgmtMnos = React.lazy(
  () => import(/* webpackChunkName: "DgmtMnos" */ './scenes/Namespaced/Dgmt/DashboardMnos')
)
const DashDgmtPbos = React.lazy(
  () => import(/* webpackChunkName: "DgmtPbos" */ './scenes/Namespaced/Dgmt/DashboardPbos')
)

const DgmtMnoListingRequests = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DgmtMnoListingRequests" */ './scenes/Namespaced/Dgmt/DashboardMnoListingRequests'
    )
)

const DgmtMnoListingRequest = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DgmtMnoListingRequest" */ './scenes/Namespaced/Dgmt/DashboardMnoListingRequest'
    )
)

const DgmtPboApplications = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DgmtPboApplications" */ './scenes/Namespaced/Dgmt/DashboardPboApplications'
    )
)

const DgmtPboApplication = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DgmtPboApplication" */ './scenes/Namespaced/Dgmt/DashboardPboApplication'
    )
)

const NewPboFormPage = React.lazy(
  () => import(/* webpackChunkName: "NewPboForm" */ './scenes/Namespaced/Dgmt/NewPboForm')
)
const AdditionalWebsiteFormPage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AdditionalWebsiteForm" */ './scenes/Namespaced/Dgmt/AdditionalWebsiteForm'
    )
)

export const DgmtDiscover = withPublicPageSkeleton(DgmtDiscoverWebsites)
export const PboApplication = withPublicPageSkeleton(DgmtPboApplication)
export const PboApplications = withPublicPageSkeleton(DgmtPboApplications)
export const MnoListingRequest = withPublicPageSkeleton(DgmtMnoListingRequest)
export const MnoListingRequests = withPublicPageSkeleton(DgmtMnoListingRequests)
export const DgmtPbos = withPublicPageSkeleton(DashDgmtPbos)
export const DgmtMnos = withPublicPageSkeleton(DashDgmtMnos)
export const DgmtHome = withPublicPageSkeleton(DgmtHomePage)
export const NewPboForm = withPublicPageSkeleton(NewPboFormPage)
export const AdditionalWebsiteForm = withPublicPageSkeleton(AdditionalWebsiteFormPage)

///
///
/// Start of Sef-specific routes
///
///

const DashRules = React.lazy(
  () => import(/* webpackChunkName: "DashRules" */ './scenes/Dashboard/DashboardRules')
)

const SipOnboardingFormPage = React.lazy(
  () =>
    import(/* webpackChunkName: "SipOnboardingForm" */ './scenes/Namespaced/Sef/SipOnboardingForm')
)

const EmployeeOnboarding = React.lazy(
  () =>
    import(
      /* webpackChunkName: "EmployeeOnboarding" */ './scenes/Namespaced/Sef/EmployeeOnboarding'
    )
)

const EmploymentAgreement = React.lazy(
  () =>
    import(
      /* webpackChunkName: "EmploymentAgreement" */ './scenes/Namespaced/Sef/EmploymentAgreement'
    )
)

const ParticipantShiftLogEntry = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ParticipantShiftLogEntry" */ './scenes/Namespaced/Sef/ParticipantShiftLogEntry'
    )
)

const TimekeeperShiftLogManagement = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TimekeeperShiftLogManagement" */ './scenes/Namespaced/Sef/TimekeeperShiftLogManagement'
    )
)

const SefDashBudgetCategory = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefBudgetCategory" */ './scenes/Namespaced/Sef/DashboardSefBudgetCategory'
    )
)

const SefDashBudgetCategories = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefBudgetCategories" */ './scenes/Namespaced/Sef/DashboardSefBudgetCategories'
    )
)

const SefDashBudgetCategoryNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefBudgetCategoryNew" */ './scenes/Namespaced/Sef/DashboardSefBudgetCategoryNew'
    )
)

const DashSefAdmins = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefAdmins" */ './scenes/Namespaced/Sef/DashboardSefAdmins'
    )
)

const DashSefPayroll = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPayroll" */ './scenes/Namespaced/Sef/DashboardSefPayroll'
    )
)
const DashSefPayslips = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPayslips" */ './scenes/Namespaced/Sef/DashboardSefPayslips'
    )
)
const DashSefPayrollRequest = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPayrollRequest" */ './scenes/Namespaced/Sef/DashboardSefPayrollRequest'
    )
)
const SefDashPayrollRequests = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPayrollRequests" */ './scenes/Namespaced/Sef/DashboardSefPayrollRequests'
    )
)
const SefDashPayrollRequestTransactions = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPayrollRequestTransactions" */ './scenes/Namespaced/Sef/DashboardSefPayrollRequestTransactions'
    )
)
const DashSefParticipants = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefParticipants" */ './scenes/Namespaced/Sef/DashboardSefParticipants'
    )
)
const DashSefBulkActionSelections = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefBulkActionSelections" */ './scenes/Namespaced/Sef/DashboardSefBulkActionSelections'
    )
)
const DashSefBulkActions = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefBulkActions" */ './scenes/Namespaced/Sef/DashboardSefBulkActions'
    )
)
const DashBulkUploadDocuments = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardBulkUploadDocuments" */ './scenes/Namespaced/Sef/DashboardBulkUploadDocuments'
    )
)
const DashboardSefTerminateParticipant = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefTerminateParticipant" */ './scenes/Namespaced/Sef/DashboardSefTerminateParticipant'
    )
)
const DashSefParticipantDetails = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefParticipantDetails" */ './scenes/Namespaced/Sef/DashboardSefParticipantDetails'
    )
)
const DashboardSefBulkTerminateParticipants = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefBulkTerminateParticipants" */ './scenes/Namespaced/Sef/DashboardSefBulkTerminateParticipants'
    )
)
const DashSefSignaturePage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefSignaturePage" */ './scenes/Namespaced/Sef/DashboardSefSignaturePage'
    )
)

const DashSefOutputsUpload = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardOutputsUpload" */ './scenes/Namespaced/Sef/DashboardOutputsUpload'
    )
)
const DashSefParticipantsUpload = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardParticipantsUpload" */ './scenes/Namespaced/Sef/DashboardParticipantsUpload'
    )
)
const DashSefKwantuUpload = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardKwantuUpload" */ './scenes/Namespaced/Sef/DashboardKwantuUpload'
    )
)
const DashSefAttendanceUpload = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardAttendanceUpload" */ './scenes/Namespaced/Sef/DashboardAttendanceUpload'
    )
)
const DashboardAttendanceProofNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardAttendanceProofNew" */ './scenes/Namespaced/Sef/DashboardAttendanceProofNew'
    )
)
const DashboardAttendanceProofReview = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardAttendanceProofReview" */ './scenes/Namespaced/Sef/DashboardAttendanceProofReview'
    )
)
const DashboardAttendanceProofs = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardAttendanceProofs" */ './scenes/Namespaced/Sef/DashboardAttendanceProofs'
    )
)
const DashboardSefPromoteParticipants = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardPromoteParticipants" */ './scenes/Namespaced/Sef/DashboardPromoteParticipants'
    )
)
const DashSefEmploymentAgreement = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardEmploymentAgreement" */ './scenes/Namespaced/Sef/DashboardEmploymentAgreement'
    )
)
const DashSefEmploymentAgreements = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardEmploymentAgreements" */ './scenes/Namespaced/Sef/DashboardEmploymentAgreements'
    )
)
const DashSefEmploymentAgreementNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardEmploymentAgreementNew" */ './scenes/Namespaced/Sef/DashboardEmploymentAgreementNew'
    )
)
const DashFormAnswers = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardFormAnswers" */ './scenes/Namespaced/Sef/DashboardFormAnswers'
    )
)
const DashForm = React.lazy(
  () => import(/* webpackChunkName: "DashboardForm" */ './scenes/Namespaced/Sef/DashboardForm')
)
const DashForms = React.lazy(
  () => import(/* webpackChunkName: "DashboardForms" */ './scenes/Namespaced/Sef/DashboardForms')
)
const DashFormNew = React.lazy(
  () =>
    import(/* webpackChunkName: "DashboardFormNew" */ './scenes/Namespaced/Sef/DashboardFormNew')
)
const DashSefActivityReports = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardActivityReports" */ './scenes/Namespaced/Sef/DashboardActivityReports'
    )
)
const DashSefDebugUser = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardDebugUser" */ './scenes/Namespaced/Sef/DashboardDebugUser'
    )
)

const SefDashDistrict = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefDistrict" */ './scenes/Namespaced/Sef/DashboardSefDistrict'
    )
)
const DashUploadHistoricalOutputs = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardUploadHistoricalOutputs" */ './scenes/Namespaced/Sef/DashboardUploadHistoricalOutputs'
    )
)

const SefDashDistrictHistory = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SefDashDistrictHistory" */ './scenes/Namespaced/Sef/DashboardSefDistrictHistory'
    )
)

const SefDashBudgets = React.lazy(
  () =>
    import(/* webpackChunkName: "DashboardBudgets" */ './scenes/Namespaced/Sef/DashboardBudgets')
)
const SefDashBudget = React.lazy(
  () => import(/* webpackChunkName: "DashboardBudget" */ './scenes/Namespaced/Sef/DashboardBudget')
)
const SefDashBudgetNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardBudgetNew" */ './scenes/Namespaced/Sef/DashboardBudgetNew'
    )
)

const SefDashDistricts = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefDistricts" */ './scenes/Namespaced/Sef/DashboardSefDistricts'
    )
)

const SefDashDistrictNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefDistrictNew" */ './scenes/Namespaced/Sef/DashboardSefDistrictNew'
    )
)

const SefDashAttendances = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SefDashAttendances" */ './scenes/Namespaced/Sef/DashboardSefAttendances'
    )
)
const SefDashboardWages = React.lazy(
  () => import(/* webpackChunkName: "DashboardWages" */ './scenes/Namespaced/Sef/DashboardWages')
)

const SefDashParticipantAttendance = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SefDashParticipantAttendance" */ './scenes/Namespaced/Sef/DashboardSefParticipantAttendance'
    )
)
const DashboardSefRegeneratePayfile = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefRegeneratePayfile" */ './scenes/Namespaced/Sef/DashboardSefRegeneratePayfile'
    )
)
const DashboardSefGenerateUifDeclaration = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefGenerateUifDeclaration" */ './scenes/Namespaced/Sef/DashboardSefGenerateUifDeclaration'
    )
)

const SefHelpPage = React.lazy(
  () => import(/* webpackChunkName: "HelpPage" */ './scenes/Namespaced/Sef/HelpPage')
)

const SefDashMuni = React.lazy(
  () =>
    import(/* webpackChunkName: "DashboardSefMuni" */ './scenes/Namespaced/Sef/DashboardSefMuni')
)

const SefDashMunis = React.lazy(
  () =>
    import(/* webpackChunkName: "DashboardSefMunis" */ './scenes/Namespaced/Sef/DashboardSefMunis')
)

const SefDashMuniNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefMuniNew" */ './scenes/Namespaced/Sef/DashboardSefMuniNew'
    )
)

const SefDashOutputArea = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefOutputArea" */ './scenes/Namespaced/Sef/DashboardSefOutputArea'
    )
)

const SefDashOutputAreas = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefOutputAreas" */ './scenes/Namespaced/Sef/DashboardSefOutputAreas'
    )
)

const SefDashOutputAreaNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefOutputAreaNew" */ './scenes/Namespaced/Sef/DashboardSefOutputAreaNew'
    )
)

const SefDashOutputs = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefOutputs" */ './scenes/Namespaced/Sef/DashboardSefOutputs'
    )
)

const OutputCsvGuidelines = React.lazy(
  () =>
    import(
      /* webpackChunkName: "OutputCsvGuidelines" */ './scenes/Namespaced/Sef/guidelines/OutputCsvGuidelines'
    )
)
const ParticipantImportCsvGuidelines = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ParticipantImportCsvGuidelines" */ './scenes/Namespaced/Sef/guidelines/ParticipantImportCsvGuidelines'
    )
)

const SefDashOutputEdit = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefOutputEdit" */ './scenes/Namespaced/Sef/DashboardSefOutputEdit'
    )
)

const SefDashOutputIndicator = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefOutputIndicator" */ './scenes/Namespaced/Sef/DashboardSefOutputIndicator'
    )
)

const SefDashOutputIndicatorHistory = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefOutputIndicatorHistory" */ './scenes/Namespaced/Sef/DashboardSefOutputIndicatorHistory'
    )
)

const SefDashOutputIndicators = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefOutputIndicators" */ './scenes/Namespaced/Sef/DashboardSefOutputIndicators'
    )
)

const SefDashOutputIndicatorNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefOutputIndicatorNew" */ './scenes/Namespaced/Sef/DashboardSefOutputIndicatorNew'
    )
)

const SefDashPartner = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPartner" */ './scenes/Namespaced/Sef/DashboardSefPartner'
    )
)

const SefDashPartners = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPartners" */ './scenes/Namespaced/Sef/DashboardSefPartners'
    )
)

const SefDashPartnerNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPartnerNew" */ './scenes/Namespaced/Sef/DashboardSefPartnerNew'
    )
)

const SefDashPurchaseRequest = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPurchaseRequest" */ './scenes/Namespaced/Sef/DashboardSefPurchaseRequest'
    )
)

const SefDashPurchaseRequests = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPurchaseRequests" */ './scenes/Namespaced/Sef/DashboardSefPurchaseRequests'
    )
)

const SefDashPurchaseRequestNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPurchaseRequestNew" */ './scenes/Namespaced/Sef/DashboardSefPurchaseRequestNew'
    )
)

const SefDashPurchaseRequestBatch = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPurchaseRequestBatch" */ './scenes/Namespaced/Sef/DashboardSefPurchaseRequestBatch'
    )
)

const SefDashPurchaseRequestBatchNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPurchaseRequestBatchNew" */ './scenes/Namespaced/Sef/DashboardSefPurchaseRequestBatchNew'
    )
)

const SefDashPurchaseRequestBatches = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefPurchaseRequestBatches" */ './scenes/Namespaced/Sef/DashboardSefPurchaseRequestBatches'
    )
)

const SefDashSupplier = React.lazy(
  () => import(/* webpackChunkName: "SefSupplier" */ './scenes/Namespaced/Sef/DashboardSefSupplier')
)

const SefDashSuppliers = React.lazy(
  () =>
    import(/* webpackChunkName: "SefSuppliers" */ './scenes/Namespaced/Sef/DashboardSefSuppliers')
)

const SefDashSupplierNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SefDashSupplierNew" */ './scenes/Namespaced/Sef/DashboardSefSupplierNew'
    )
)

const SefDashWard = React.lazy(
  () =>
    import(/* webpackChunkName: "DashboardSefWard" */ './scenes/Namespaced/Sef/DashboardSefWard')
)

const SefDashWards = React.lazy(
  () =>
    import(/* webpackChunkName: "DashboardSefWards" */ './scenes/Namespaced/Sef/DashboardSefWards')
)

const SefDashWardNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWardNew" */ './scenes/Namespaced/Sef/DashboardSefWardNew'
    )
)

const SefDashWorkspace = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorkspace" */ './scenes/Namespaced/Sef/DashboardSefWorkspace'
    )
)

const SefDashWorkspaces = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorkspaces" */ './scenes/Namespaced/Sef/DashboardSefWorkspaces'
    )
)

const SefDashWorkspaceNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorkspaceNew" */ './scenes/Namespaced/Sef/DashboardSefWorkspaceNew'
    )
)

const GemDashPrograms = React.lazy(
  () =>
    import(/* webpackChunkName: "DashboardPrograms" */ './scenes/Namespaced/Sef/DashboardPrograms')
)

const SefDashWorkspaceProject = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorkspaceProject" */ './scenes/Namespaced/Sef/DashboardSefWorkspaceProject'
    )
)

const SefDashWorkspaceProjects = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorkspaceProjects" */ './scenes/Namespaced/Sef/DashboardSefWorkspaceProjects'
    )
)

const SefDashWorkspaceProjectNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorkspaceProjectNew" */ './scenes/Namespaced/Sef/DashboardSefWorkspaceProjectNew'
    )
)

const SefDashWorksite = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorksite" */ './scenes/Namespaced/Sef/DashboardSefWorksite'
    )
)

const SefDashWorksiteHistory = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorksiteHistory" */ './scenes/Namespaced/Sef/DashboardSefWorksiteHistory'
    )
)

const SefDashWorksiteDataPortals = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorksiteDataPortals" */ './scenes/Namespaced/Sef/DashboardSefWorksiteDataPortals'
    )
)

const SefDashWorksites = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorksites" */ './scenes/Namespaced/Sef/DashboardSefWorksites'
    )
)
const SefDashWorksiteEmployees = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorksiteEmployees" */ './scenes/Namespaced/Sef/DashboardSefWorksiteEmployees'
    )
)

const SefDashWorksiteNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardSefWorksiteNew" */ './scenes/Namespaced/Sef/DashboardSefWorksiteNew'
    )
)

const AceSideHustle = React.lazy(
  () => import(/* webpackChunkName: "AceSideHustle" */ './scenes/Namespaced/Ace/SideHustle')
)
const AceSideHustles = React.lazy(
  () => import(/* webpackChunkName: "AceSideHustles" */ './scenes/Namespaced/Ace/SideHustles')
)
const AceSideHustleNew = React.lazy(
  () => import(/* webpackChunkName: "AceSideHustleNew" */ './scenes/Namespaced/Ace/SideHustleNew')
)
const AceTrainingRecord = React.lazy(
  () => import(/* webpackChunkName: "AceTrainingRecord" */ './scenes/Namespaced/Ace/TrainingRecord')
)
const AceTrainingRecords = React.lazy(
  () =>
    import(/* webpackChunkName: "AceTrainingRecords" */ './scenes/Namespaced/Ace/TrainingRecords')
)
const AceTrainingRecordNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AceTrainingRecordNew" */ './scenes/Namespaced/Ace/TrainingRecordNew'
    )
)
const AceTrainingTemplateNew = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AceTrainingTemplateNew" */ './scenes/Namespaced/Ace/TrainingTemplateNew'
    )
)
const AceTrainingTemplates = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AceTrainingTemplates" */ './scenes/Namespaced/Ace/TrainingTemplates'
    )
)
const AceTrainingTemplate = React.lazy(
  () =>
    import(/* webpackChunkName: "AceTrainingTemplate" */ './scenes/Namespaced/Ace/TrainingTemplate')
)
const AceBulkAssignTemplate = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AceBulkAssignTemplate" */ './scenes/Namespaced/Ace/DashboardAceBulkAssignTemplate'
    )
)
const AceWorkRecord = React.lazy(
  () => import(/* webpackChunkName: "AceWorkRecord" */ './scenes/Namespaced/Ace/WorkRecord')
)
const AceWorkRecords = React.lazy(
  () => import(/* webpackChunkName: "AceWorkRecords" */ './scenes/Namespaced/Ace/WorkRecords')
)
const AceWorkRecordNew = React.lazy(
  () => import(/* webpackChunkName: "AceWorkRecordNew" */ './scenes/Namespaced/Ace/WorkRecordNew')
)

export const SefEmployeeOnboarding = withPublicPageSkeleton(EmployeeOnboarding)
export const SipOnboardingForm = withPublicPageSkeleton(SipOnboardingFormPage)
export const SefEmploymentAgreement = withPublicPageSkeleton(EmploymentAgreement)
export const SefParticipantShiftLogEntry = withPublicPageSkeleton(ParticipantShiftLogEntry)
export const SefTkShiftLogManagement = withPublicPageSkeleton(TimekeeperShiftLogManagement)
export const SefBudgetCategory = withDashboardSkeleton(SefDashBudgetCategory)
export const SefBudgetCategories = withDashboardSkeleton(SefDashBudgetCategories)
export const SefBudgetCategoryNew = withDashboardSkeleton(SefDashBudgetCategoryNew)
export const SefAdmins = withDashboardSkeleton(DashSefAdmins)
export const SefPayroll = withDashboardSkeleton(DashSefPayroll)
export const SefPayslips = withDashboardSkeleton(DashSefPayslips)
export const SefPayrollRequest = withDashboardSkeleton(DashSefPayrollRequest)
export const SefPayrollRequests = withDashboardSkeleton(SefDashPayrollRequests)
export const SefPayrollRequestTransactions = withDashboardSkeleton(
  SefDashPayrollRequestTransactions
)
export const SefBulkActionSelections = withDashboardSkeleton(DashSefBulkActionSelections)
export const SefBulkActions = withDashboardSkeleton(DashSefBulkActions)
export const SefBulkUploadDocuments = withDashboardSkeleton(DashBulkUploadDocuments)
export const SefParticipants = withDashboardSkeleton(DashSefParticipants)
export const SefParticipantDetails = withDashboardSkeleton(DashSefParticipantDetails)
export const SefParticipantTermination = withDashboardSkeleton(DashboardSefTerminateParticipant)
export const SefBulkTerminateParticipants = withDashboardSkeleton(
  DashboardSefBulkTerminateParticipants
)
export const SefOutputsUpload = withDashboardSkeleton(DashSefOutputsUpload)
export const SefKwantuUpload = withDashboardSkeleton(DashSefKwantuUpload)
export const SefParticipantsUpload = withDashboardSkeleton(DashSefParticipantsUpload)
export const SefAttendanceUpload = withDashboardSkeleton(DashSefAttendanceUpload)
export const SefAttendanceProofNew = withDashboardSkeleton(DashboardAttendanceProofNew)
export const SefAttendanceProofReview = withDashboardSkeleton(DashboardAttendanceProofReview)
export const SefAttendanceProofs = withDashboardSkeleton(DashboardAttendanceProofs)
export const SefPromoteParticipants = withDashboardSkeleton(DashboardSefPromoteParticipants)
export const SefFormAnswers = withDashboardSkeleton(DashFormAnswers)
export const SefFormEdit = withDashboardSkeleton(DashForm)
export const SefForms = withDashboardSkeleton(DashForms)
export const SefFormNew = withDashboardSkeleton(DashFormNew)
export const SefEmploymentAgreementEdit = withDashboardSkeleton(DashSefEmploymentAgreement)
export const SefEmploymentAgreements = withDashboardSkeleton(DashSefEmploymentAgreements)
export const SefEmploymentAgreementNew = withDashboardSkeleton(DashSefEmploymentAgreementNew)
export const SefActivityReports = withDashboardSkeleton(DashSefActivityReports)
export const SefDebugUser = withDashboardSkeleton(DashSefDebugUser)
export const SefSignaturePage = withDashboardSkeleton(DashSefSignaturePage)
export const SefUploadHistoricalOutputs = withDashboardSkeleton(DashUploadHistoricalOutputs)
export const SefDistrict = withDashboardSkeleton(SefDashDistrict)
export const SefDistrictHistory = withDashboardSkeleton(SefDashDistrictHistory)
export const SefBudgetNew = withDashboardSkeleton(SefDashBudgetNew)
export const SefBudget = withDashboardSkeleton(SefDashBudget)
export const SefBudgets = withDashboardSkeleton(SefDashBudgets)
export const SefDistricts = withDashboardSkeleton(SefDashDistricts)
export const SefDistrictNew = withDashboardSkeleton(SefDashDistrictNew)
export const SefAttendances = withDashboardSkeleton(SefDashAttendances)
export const DashboardWages = withDashboardSkeleton(SefDashboardWages)
export const SefSetParticipantAttendance = withDashboardSkeleton(SefDashParticipantAttendance)
export const SefRegeneratePayfile = withDashboardSkeleton(DashboardSefRegeneratePayfile)
export const SefGenerateUifDeclaration = withDashboardSkeleton(DashboardSefGenerateUifDeclaration)
export const HelpPage = withDashboardSkeleton(SefHelpPage)
export const SefMuni = withDashboardSkeleton(SefDashMuni)
export const SefMunis = withDashboardSkeleton(SefDashMunis)
export const SefMuniNew = withDashboardSkeleton(SefDashMuniNew)
export const SefOutputArea = withDashboardSkeleton(SefDashOutputArea)
export const SefOutputAreas = withDashboardSkeleton(SefDashOutputAreas)
export const SefOutputs = withDashboardSkeleton(SefDashOutputs)
export const SefOutputEdit = withDashboardSkeleton(SefDashOutputEdit)
export const SefOutputGuidelines = withDashboardSkeleton(OutputCsvGuidelines)
export const SefParticipantImportGuidelines = withDashboardSkeleton(ParticipantImportCsvGuidelines)
export const SefOutputAreaNew = withDashboardSkeleton(SefDashOutputAreaNew)
export const SefOutputIndicator = withDashboardSkeleton(SefDashOutputIndicator)
export const SefOutputIndicatorHistory = withDashboardSkeleton(SefDashOutputIndicatorHistory)
export const SefOutputIndicators = withDashboardSkeleton(SefDashOutputIndicators)
export const SefOutputIndicatorNew = withDashboardSkeleton(SefDashOutputIndicatorNew)
export const SefPartner = withDashboardSkeleton(SefDashPartner)
export const SefPartners = withDashboardSkeleton(SefDashPartners)
export const SefPartnerNew = withDashboardSkeleton(SefDashPartnerNew)
export const SefPurchaseRequest = withDashboardSkeleton(SefDashPurchaseRequest)
export const SefPurchaseRequests = withDashboardSkeleton(SefDashPurchaseRequests)
export const SefPurchaseRequestNew = withDashboardSkeleton(SefDashPurchaseRequestNew)
export const SefPurchaseRequestBatch = withDashboardSkeleton(SefDashPurchaseRequestBatch)
export const SefPurchaseRequestBatches = withDashboardSkeleton(SefDashPurchaseRequestBatches)
export const SefPurchaseRequestBatchNew = withDashboardSkeleton(SefDashPurchaseRequestBatchNew)
export const SefSupplier = withDashboardSkeleton(SefDashSupplier)
export const SefSuppliers = withDashboardSkeleton(SefDashSuppliers)
export const SefSupplierNew = withDashboardSkeleton(SefDashSupplierNew)
export const SefWard = withDashboardSkeleton(SefDashWard)
export const SefWards = withDashboardSkeleton(SefDashWards)
export const SefWardNew = withDashboardSkeleton(SefDashWardNew)
export const SefWorkspace = withDashboardSkeleton(SefDashWorkspace)
export const SefWorkspaces = withDashboardSkeleton(SefDashWorkspaces)
export const SefWorkspaceNew = withDashboardSkeleton(SefDashWorkspaceNew)
export const GemPrograms = withDashboardSkeleton(GemDashPrograms)
export const SefWorkspaceProject = withDashboardSkeleton(SefDashWorkspaceProject)
export const SefWorkspaceProjects = withDashboardSkeleton(SefDashWorkspaceProjects)
export const SefWorkspaceProjectNew = withDashboardSkeleton(SefDashWorkspaceProjectNew)
export const SefWorksite = withDashboardSkeleton(SefDashWorksite)
export const SefWorksiteDataPortals = withDashboardSkeleton(SefDashWorksiteDataPortals)
export const SefWorksiteHistory = withDashboardSkeleton(SefDashWorksiteHistory)
export const SefWorksites = withDashboardSkeleton(SefDashWorksites)
export const SefWorksiteEmployees = withDashboardSkeleton(SefDashWorksiteEmployees)
export const SefWorksiteNew = withDashboardSkeleton(SefDashWorksiteNew)

///
///
/// End of Sef-specific routes
///
///

export const Terms = withPublicPageSkeleton(AsyncTerms)
export const AboutUs = withPublicPageSkeleton(AsyncAboutUs)
export const Careers = withPublicPageSkeleton(AsyncCareers)
export const HomePage = withPublicPageSkeleton(AsyncHomePage)
export const SefHomePage = withPublicPageSkeleton(AsyncSefHomePage)
export const ExtrasPage = withPublicPageSkeleton(AsyncExtrasPage)
export const FeedPage = withPublicPageSkeleton(AsyncFeedPage)
export const NonprofitPricing = withPublicPageSkeleton(AsyncNonprofitPricing)
export const BusinessPricing = withPublicPageSkeleton(AsyncBusinessPricing)
export const EducationPricing = withPublicPageSkeleton(AsyncEducationPricing)
export const Pricing = withPublicPageSkeleton(AsyncPricingIndex)
export const ProcessDonation = withPublicPageSkeleton(AsyncProcessDonation)
export const ProcessPlatformPayment = withPublicPageSkeleton(AsyncProcessPlatformPayment)
export const PrivacyPolicy = withPublicPageSkeleton(AsyncPrivacyPolicy)
export const DocsPage = withPublicPageSkeleton(AsyncDocsPage)
export const NotFound = withPublicPageSkeleton(AsyncNotFound)
export const InstagramBioLinks = withPublicPageSkeleton(AsyncInstagramBioLinks)
export const Campaign = withPublicPageSkeleton(AsyncCampaign)
export const EmailConfirmation = withPublicPageSkeleton(AsyncEmailConfirmation)
export const Probation = withPublicPageSkeleton(AsyncProbation)
export const Opportunity = withPublicPageSkeleton(AsyncOpportunity)

export const OrgActivity = withPublicPageSkeleton(AsyncOrgActivity)
export const OrgBenefactors = withPublicPageSkeleton(AsyncOrgBenefactors)
export const OrgCauses = withPublicPageSkeleton(AsyncOrgCauses)
export const OrgDescription = withPublicPageSkeleton(AsyncOrgDescription)
export const OrgFaqs = withPublicPageSkeleton(AsyncOrgFaqs)
export const OrgGoal = withPublicPageSkeleton(AsyncOrgGoal)
export const OrgGoals = withPublicPageSkeleton(AsyncOrgGoals)
export const OrgWebsites = withPublicPageSkeleton(AsyncOrgWebsites)

export const ManageOrgInvite = withPublicPageSkeleton(AsyncManageOrgInvite)
export const RequestOrganisationMembership = withPublicPageSkeleton(
  AsyncRequestOrganisationMembership
)
export const ClaimOrganisation = withPublicPageSkeleton(AsyncClaimOrganisation)
export const ClaimOrganisationRequest = withPublicPageSkeleton(AsyncClaimOrganisationRequest)
export const HostFeedback = withPublicPageSkeleton(AsyncHostFeedback)
export const MoneyDonationConfirmation = withPublicPageSkeleton(AsyncMoneyDonationConfirmation)
export const OrgMoneyDonationConfirmation = withPublicPageSkeleton(
  AsyncOrgMoneyDonationConfirmation
)

export const GoodsDonationConfirmation = withPublicPageSkeleton(AsyncGoodsDonationConfirmation)
export const OrgGoodsDonationConfirmation = withPublicPageSkeleton(
  AsyncOrgGoodsDonationConfirmation
)
export const VolunteerFeedback = withPublicPageSkeleton(AsyncVolunteerFeedback)
export const PersonalGoodsDonationConfirmationRequest = withPublicPageSkeleton(
  AsyncPersonalGoodsDonationConfirmationRequest
)
export const PersonalMoneyDonationConfirmationRequest = withPublicPageSkeleton(
  AsyncPersonalMoneyDonationConfirmationRequest
)
export const OrgGoodsDonationConfirmationRequest = withPublicPageSkeleton(
  AsyncOrgGoodsDonationConfirmationRequest
)
export const OrgMoneyDonationConfirmationRequest = withPublicPageSkeleton(
  AsyncOrgMoneyDonationConfirmationRequest
)
export const ChallengeCheckin = withPublicPageSkeleton(AsyncChallengeCheckin)
export const Specs = withPublicPageSkeleton(AsyncSpecs)

export const CompaniesMarketingPage = withPublicPageSkeleton(AsyncCompaniesMarketingPage)
export const EducationMarketingPage = withPublicPageSkeleton(AsyncEducationMarketingPage)
export const IndividualsMarketingPage = withPublicPageSkeleton(AsyncIndividualsMarketingPage)
export const NonprofitsMarketingPage = withPublicPageSkeleton(AsyncNonprofitsMarketingPage)
export const Campaigns = withPublicPageSkeleton(AsyncCampaigns)
export const Categories = withPublicPageSkeleton(AsyncCategories)
export const ChallengeSearch = withPublicPageSkeleton(AsyncChallengeSearch)
export const NonProfitSearch = withPublicPageSkeleton(AsyncNonProfitSearch)
export const OppSearch = withPublicPageSkeleton(AsyncOppSearch)
export const OrgSearch = withPublicPageSkeleton(AsyncOrgSearch)
export const Values = withPublicPageSkeleton(AsyncValues)

export const JoinBrowniePoints = withAuthSkeleton(AsyncJoinBrowniePoints)
export const CompleteOnboarding = withDashboardSkeleton(AsyncCompleteOnboarding)

export const Stories = withDashboardSkeleton(AsyncStories)

export const OzowDonationCompletion = withPublicPageSkeleton(AsyncOzowDonationCompletion)
export const OzowDonationFailure = withPublicPageSkeleton(AsyncOzowDonationFailure)

export const Login = withAuthSkeleton(AsyncLogin)
export const PasswordReset = withAuthSkeleton(AsyncPasswordReset)
export const MagicLogin = withAuthSkeleton(AsyncMagicLogin)
export const PasswordSetup = withAuthSkeleton(AsyncPasswordSetup)

export const Dashboard = withDashboardSkeleton(DashboardHome)
export const Rules = withDashboardSkeleton(DashRules)
export const DashboardAssetUpload = withDashboardSkeleton(DashAssetUpload)
export const DashboardInstagramBioLinks = withDashboardSkeleton(DashInstagramBioLinks)
export const DashboardBilling = withDashboardSkeleton(DashboardBill)
export const DashboardBillingSelection = withDashboardSkeleton(DashboardBillSelection)
export const DashboardContributions = withDashboardSkeleton(DashContributions)
export const DashboardChallenges = withDashboardSkeleton(DashChallenges)
export const DashboardChallenge = withDashboardSkeleton(DashChallenge)
export const DashboardNewChallenges = withDashboardSkeleton(DashChallengesNew)
export const DashboardReceivedLikes = withDashboardSkeleton(DashReceivedLikes)
export const DashboardNotifications = withDashboardSkeleton(DashNotifications)
export const DashboardSubscriptions = withDashboardSkeleton(DashSubscriptions)
export const DashboardOpportunities = withDashboardSkeleton(DashboardOpps)
export const DashboardNewOpportunities = withDashboardSkeleton(DashboardOppsNew)
export const DashboardOpportunity = withDashboardSkeleton(DashboardOpp)
export const DashboardOppActivity = withDashboardSkeleton(DashOppActivity)
export const DashboardOppPersonActivity = withDashboardSkeleton(DashOppPersonActivity)
export const DashboardPersonActivity = withDashboardSkeleton(DashPersonActivity)
export const DashboardUpdateMembership = withDashboardSkeleton(DashUpdateMembership)
export const DashboardParticipantDocuments = withDashboardSkeleton(DashParticipantDocuments)
export const DashboardCampaign = withDashboardSkeleton(DashboardCamp)
export const DashboardCampaigns = withDashboardSkeleton(DashboardCamps)
export const DashboardNewCampaign = withDashboardSkeleton(DashboardCampNew)
export const DashboardOrganization = withDashboardSkeleton(DashboardOrg)
export const DashboardOrganisationMembers = withDashboardSkeleton(DashboardOrgMembers)
export const DashboardOrganisationVerify = withDashboardSkeleton(DashboardOrgVerify)
export const DashboardOrganisationFaq = withDashboardSkeleton(DashboardOrgFaq)
export const DashboardOrganisationFaqs = withDashboardSkeleton(DashboardOrgFaqs)
export const DashboardOrganisationFaqNew = withDashboardSkeleton(DashboardOrgFaqNew)
export const DashboardOrganisationGoal = withDashboardSkeleton(DashboardOrgGoal)
export const DashboardOrganisationGoals = withDashboardSkeleton(DashboardOrgGoals)
export const DashboardOrganisationGoalNew = withDashboardSkeleton(DashboardOrgGoalNew)
export const DashboardOrganisationGoalMilestone = withDashboardSkeleton(DashboardOrgGoalMilestone)
export const DashboardOrganisationGoalMilestoneNew = withDashboardSkeleton(
  DashboardOrgGoalMilestoneNew
)
export const DashboardOrganizations = withDashboardSkeleton(DashboardOrgs)
export const DashboardBoost = withDashboardSkeleton(DashBoost)
export const DashboardNewOrganization = withDashboardSkeleton(DashboardOrgNew)
export const DashboardNewPeople = withDashboardSkeleton(DashboardPeopleNew)
export const DashboardPeople = withDashboardSkeleton(AsyncDashboardPeople)
export const DashboardNewTeam = withDashboardSkeleton(DashboardTeamNew)
export const DashboardSquads = withDashboardSkeleton(DashSquads)
export const DashboardTeams = withDashboardSkeleton(DashTeams)
export const DashboardTeam = withDashboardSkeleton(DashTeam)
export const DashboardTeamMembers = withDashboardSkeleton(DashTeamMembers)
export const DashboardTeamGroup = withDashboardSkeleton(DashTeamGroup)
export const DashboardAccount = withDashboardSkeleton(DashAccount)
export const DashboardUserAccountPrefs = withDashboardSkeleton(DashUserAccountPrefs)
export const DashboardNotFound = withDashboardSkeleton(DashNotFound)
export const DashboardPlatformEvents = withDashboardSkeleton(DashPlatformEvents)
export const DashboardEmailActivity = withDashboardSkeleton(DashEmailActivity)
export const DashboardPersonalGoals = withDashboardSkeleton(DashPersonalGoals)
export const DashboardPersonalGoalNew = withDashboardSkeleton(DashPersonalGoalNew)
export const DashboardStories = withDashboardSkeleton(DashStories)
export const DashboardStory = withDashboardSkeleton(DashStory)
export const DashboardStoryNew = withDashboardSkeleton(DashStoryNew)

export const User = withPublicPageSkeleton(AsyncUser)
export const UserChallenges = withPublicPageSkeleton(AsyncUserChallenges)
export const HostedOpps = withPublicPageSkeleton(AsyncUserHostedOpps)
export const JoinedOpps = withPublicPageSkeleton(AsyncUserJoinedOpps)
export const UserStories = withPublicPageSkeleton(AsyncUserStories)
export const UserOrgs = withPublicPageSkeleton(AsyncUserOrgs)

export const SideHustle = withDashboardSkeleton(AceSideHustle)
export const SideHustles = withDashboardSkeleton(AceSideHustles)
export const SideHustleNew = withDashboardSkeleton(AceSideHustleNew)
export const TrainingRecord = withDashboardSkeleton(AceTrainingRecord)
export const TrainingRecords = withDashboardSkeleton(AceTrainingRecords)
export const TrainingRecordNew = withDashboardSkeleton(AceTrainingRecordNew)
export const TrainingTemplateNew = withDashboardSkeleton(AceTrainingTemplateNew)
export const TrainingTemplates = withDashboardSkeleton(AceTrainingTemplates)
export const TrainingTemplate = withDashboardSkeleton(AceTrainingTemplate)
export const BulkAssignTemplate = withDashboardSkeleton(AceBulkAssignTemplate)
export const WorkRecord = withDashboardSkeleton(AceWorkRecord)
export const WorkRecords = withDashboardSkeleton(AceWorkRecords)
export const WorkRecordNew = withDashboardSkeleton(AceWorkRecordNew)

//
// LevelUp routes
//

const AsyncLevelUpHomePage = React.lazy(
  () => import(/* webpackChunkName: "LevelUpHome" */ './scenes/Namespaced/LevelUp/LevelUpHome')
)
const AsyncLevelUpOnboardingPage = React.lazy(
  () => import(/* webpackChunkName: "LevelUpOnboarding" */ './scenes/Namespaced/LevelUp/Onboarding')
)
const AsyncLevelUpLearnPage = React.lazy(
  () => import(/* webpackChunkName: "LevelUpLearn" */ './scenes/Namespaced/LevelUp/LearnPage')
)
const AsyncLevelUpHealPage = React.lazy(
  () => import(/* webpackChunkName: "LevelUpHeal" */ './scenes/Namespaced/LevelUp/HealPage')
)
const AsyncLevelUpDiscoverPage = React.lazy(
  () => import(/* webpackChunkName: "LevelUpDiscover" */ './scenes/Namespaced/LevelUp/DiscoverPage')
)
const AsyncLevelUpSharePage = React.lazy(
  () => import(/* webpackChunkName: "LevelUpShare" */ './scenes/Namespaced/LevelUp/SharePage')
)

export const LevelUpHomePage = withPublicPageSkeleton(AsyncLevelUpHomePage)
export const LevelUpOnboardingForm = withPublicPageSkeleton(AsyncLevelUpOnboardingPage)
export const LevelUpLearnPage = withPublicPageSkeleton(AsyncLevelUpLearnPage)
export const LevelUpHealPage = withPublicPageSkeleton(AsyncLevelUpHealPage)
export const LevelUpDiscoverPage = withPublicPageSkeleton(AsyncLevelUpDiscoverPage)
export const LevelUpSharePage = withPublicPageSkeleton(AsyncLevelUpSharePage)
